export const UPDATE_LAST_SWATCH_APPLIED = "UPDATE_LAST_SWATCH_APPLIED";
export const UPDATE_PREVIOUS_SWATCH = "UPDATE_PREVIOUS_SWATCH";
export const CLEAN_UNDO = "CLEAN_UNDO";
export const UPDATE_PREVIOUS_RECIPE = "UPDATE_PREVIOUS_RECIPE";
export const CLEAN_RECIPE = "CLEAN_RECIPE";
export const HAS_UNDO_BEEN_APPLIED = "HAS_UNDO_BEEN_APPLIED";
export const COMPONENTS = "COMPONENTS";
export const INIT_COMPONENTS = "INIT_COMPONENTS";